<template>
    <confirm-dialog
        v-model="dialog"
        :title="title"
        :text="text"
        :confirm-text="approve ? 'Approve' : 'Reject'"
        :color="approve ? 'black' : 'red darken-1'"
        :icon="approve ? 'mdi-check-circle-outline' : 'mdi-alert-outline'"
        :loading="loading"
        @confirm="review"
    />
</template>

<script>
    import ConfirmDialog from '@/components/ConfirmDialog'
    import postponementService from '@/services/postponement'
    import matchChangeService from '@/services/match-change'
    import { errorMessage, slotTeams } from '@/utils/requests'

    // Approve / reject a postponement or a match change, after a confirmation. Emits `done` with { ok, message }.
    export default {
        name: 'RequestReviewDialog',
        components: { ConfirmDialog },
        data() {
            return {
                dialog: false,
                loading: false,
                type: null,
                request: null,
                approve: false
            }
        },
        computed: {
            title() {
                const what = this.type === 'change' ? 'match change' : 'postponement'
                return `${this.approve ? 'Approve' : 'Reject'} ${what}?`
            },
            text() {
                if (!this.request) return null
                if (this.type === 'change') {
                    const matches = `${slotTeams(this.request.match1)} and ${slotTeams(this.request.match2)}`
                    return this.approve
                        ? `${matches} swap their date, time and arena. The followers of the teams and the captains are notified.`
                        : `The matches stay as they are. The captains of the teams are notified.`
                }
                const match = `${this.request.team1Name} - ${this.request.team2Name}`
                return this.approve
                    ? `${match} will be postponed and the followers of both teams will be notified.`
                    : `${this.request.teamName} gets the postponement back and the captain is notified.`
            }
        },
        methods: {
            open(type, request, approve) {
                this.type = type
                this.request = request
                this.approve = approve
                this.dialog = true
            },
            review() {
                const id = this.request.id
                let call
                if (this.type === 'change') {
                    call = this.approve ? matchChangeService.approveMatchChange(id) : matchChangeService.rejectMatchChange(id)
                } else {
                    call = this.approve ? postponementService.approvePostponement(id) : postponementService.rejectPostponement(id)
                }
                const success = this.type === 'change'
                    ? (this.approve ? 'The matches are swapped' : 'The match change is rejected')
                    : (this.approve ? 'The match is postponed' : 'The postponement is rejected')
                this.loading = true
                call.then(() => {
                    this.$emit('done', { ok: true, message: success })
                }).catch(error => {
                    this.$emit('done', { ok: false, message: errorMessage(error) })
                }).finally(() => {
                    this.loading = false
                    this.dialog = false
                })
            }
        }
    }
</script>
